import { KoAssertsView, KoButton, KoForm, KoLoader,  KoModal,  KoTable, KoTitle, KoToast, KoTooltips, KoUpload } from 'packages';
import KoIcon from '@kwapio/icons';
import React, { useState, useEffect } from 'react';

import ProductObject from '../constant';
import styles from './curd.module.scss';
import { downloadFile } from 'pages/drive/downloaddocx';
import { OrdersAPI } from '../../../orders.service';
import { getCookie } from 'shared/utils/cookies';
export default function Media({ticketId, className, refresh, workspaceId, onRemoveFile, setAttachementsList }) {
  const [files, setFiles] = useState();
  const [loading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [openFileCreate, setOpenFileCreate] = useState(false);
  const [savingTextStatus, setSavingTextStatus] = useState('');
  const [uploadFileModal, setUploadFileModal] = useState(false);

  useEffect(() => {
    if(!ticketId){
      return;
    }
    setLoading(true);
    OrdersAPI.getAttachments(ticketId, workspaceId).then(
      (data) => {
        setLoading(false);
        setFiles(data['attachments']);
        setAttachementsList &&setAttachementsList(data['attachments']);
      },
      (err) => {
        setLoading(false);
        console.log(err);
      }
    );
  }, [refresh]);

  const onCellClick = (data) => {
    if (data?.type === 'docx') {
      window.open(`/open/document/root/${data?.uid}`, '_blank');

    }else{
      setCurrentRecord(data);
      setOpenFileCreate(true);
    }
   
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.table} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        <KoTooltips title={'Download'}>
          <KoButton className={'btn'} iconBtn={true} onClick={() => downloadFile(row?.url, currentRecord?.name || row?.name, setLoading)}  icon={<KoIcon width={14} height={14} name={'DownloadOutlined'} />} />
        </KoTooltips>
        {onRemoveFile && row?.uid?.includes('rc-') &&  <KoTooltips title={'Delete'}>
          <KoButton onClick={() => onRemoveFile(row)}  className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
        </KoTooltips>}
      </div>;
    }
  }];

  const props = {
    name: 'files',
    multiple: true,
    accept: 'image/*,video/*',
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { service: getCookie('wos'), module: 'taskplanner', lookupId: 'lookupId' },
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },

    onChange(info) {
      setLoading(true);
      if (info.file.status !== 'uploading') {
      }
      const { fileList } = info;

    // Check if all uploads have either completed or failed
      const allFinished = fileList.every(
        file => file.status === 'done' || file.status === 'error'
      );

      if (allFinished) {
        setLoading(true);

        const successfulFiles = fileList
          .filter(file => file.status === 'done')
          .map(file => ({
            name: file.name,
            type: file.type,
            size: file.size,
            uid: file.uid,
            lastModifiedDate: file.lastModifiedDate || new Date().toISOString()
          }));

        console.log('successfulFiles', successfulFiles);
      }
      else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  
  return (
    <div className={`${styles.wrapper}`}>
      {loading && <KoLoader />}
      <div className={`${styles.attachments}`}>
        <KoTitle level={4} text={'Media'} />
        <KoButton onClick={()=>setUploadFileModal(true)} color="purple" variant="outlined" className={'btn'} label={'Upload'} icon={<KoIcon color="#9154de" width={14} height={14} name={'AttachmentOutlined'} />} />
      </div>
      <div className={styles.table}>
        <KoTable rowKey={'uid'}
          onCellClick={onCellClick}
          data={{ columns: ProductObject.COLUMNS_ATTACHMENTS, rows: files }}
          extraColumnsRight={columnsRight}
          maxHeight={79} />
      </div>
      {openFileCreate && <KoAssertsView
        openFileCreate={openFileCreate}
        showComments={false}
        source={'attachments'}
        isLoading={loading}
        savingTextStatus={savingTextStatus}
        actions={['download', 'updated']}
        onDownload={() => {downloadFile(currentRecord?.url, currentRecord?.name, setLoading, setSavingTextStatus('Downloading...'));}}
        fileDetails={currentRecord}
        setOpenFileCreate={setOpenFileCreate}
        documentId={currentRecord?.documentId} />}

      <KoModal
        title={'Upload Media'}
        centered
        open={uploadFileModal}
        handleOk={() => { setUploadFileModal(false); }}
        onClose={() => { setUploadFileModal(false); }}
        width={760}
        footer={[]}
      >
        <div className={`${styles.uploadWrapper} customUpload`}>
          {loading && <KoLoader circle={false} />}
          <KoForm.Item
            name={["attachments"]}
            valuePropName={["attachments"]}
            getValueFromEvent={normFile}>
            <KoUpload
              isDnd={true}
              listType="picture"
              {...props}
            >
              <div className={styles.upload}>
                <p className="ant-upload-text">{`Click or drag file to this area to upload`} </p>
                <p className="ant-upload-hint">
                  Support for single or bulk uploads. Uploading banned files is strictly prohibited.
                </p>
              </div>
            </KoUpload>
          </KoForm.Item>
        </div>
      </KoModal>
    </div>
   
  );
}
